module.exports = __webpack_public_path__ + "static/media/lilProjimg.cdc52cc7.png";